import React from "react";
import { Box, Button, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";
import { buttonStyle } from "../constants/Style";

export default function NotAuthorized() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: theme.customColors.neutral[70],
      }}
    >
      <Typography variant="h1" sx={{ color: "white", marginBottom: 2 }}>
        401
      </Typography>
      <Typography variant="h6" sx={{ color: "white", marginBottom: 10 }}>
        شما دسترسی به این صفحه ندارید
      </Typography>
      <Button sx={{ ...buttonStyle(theme) }} component={Link} to="/">
        برگشت به خانه
      </Button>
    </Box>
  );
}
